import React from "react";
import {
  Box,
  Typography,
  Grid,
  Divider,
  IconButton,
  Container,
} from "@mui/material";
import { Facebook, Instagram, YouTube, Twitter } from "@mui/icons-material"; // Importing YouTube Icon
import { Link } from "react-router-dom"; // Importing Link from react-router-dom

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#0B0F19",
        color: "#FFFFFF",
        paddingY: "60px",
        borderTop: "3px solid #0B0F19",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Column 1: Logo and Tagline */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                marginBottom: "16px",
                fontSize: "1.8rem",
                color: "#00BFFF",
                letterSpacing: "0.1em",
              }}
            >
              SHALL
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "#A9C9EA",
                marginBottom: "24px",
                maxWidth: "300px",
                lineHeight: 1.6,
              }}
            >
              Empowering minds.| Building a brighter future.| Inspiring
              progress.
            </Typography>
            <Box sx={{ display: "flex", gap: "12px", marginTop: "16px" }}>
              <IconButton
                href="https://www.facebook.com/shallFoundation"
                target="_blank"
                sx={{ color: "#A9C9EA", "&:hover": { color: "#00BFFF" } }}
              >
                <Facebook />
              </IconButton>
              <IconButton
                href="https://www.instagram.com"
                target="_blank"
                sx={{ color: "#A9C9EA", "&:hover": { color: "#00BFFF" } }}
              >
                <Instagram />
              </IconButton>
              <IconButton
                href="https://youtube.com/@shallmedia"
                target="_blank"
                sx={{ color: "#A9C9EA", "&:hover": { color: "#00BFFF" } }}
              >
                <YouTube />
              </IconButton>
              <IconButton
                href="https://x.com/AYFDA_Official"
                target="_blank"
                sx={{ color: "#A9C9EA", "&:hover": { color: "#00BFFF" } }}
              >
                <Twitter /> {/* Twitter icon to represent X */}
              </IconButton>
            </Box>
          </Grid>

          {/* Column 2: Quick Links */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, marginBottom: "16px", fontSize: "1.2rem" }}
            >
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {/* Specific routes for Home and About Us */}
              <Link
                to="/"
                style={{
                  color: "#A9C9EA",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  position: "relative",
                  display: "inline-block",
                  paddingBottom: "4px",
                  transition: "all 0.3s ease",
                }}
              >
                Home
                <Box
                  component="span"
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: 0,
                    height: "2px",
                    backgroundColor: "#00BFFF",
                    transition: "all 0.3s ease",
                  }}
                />
              </Link>

              <Link
                to="/about/"
                style={{
                  color: "#A9C9EA",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  position: "relative",
                  display: "inline-block",
                  paddingBottom: "4px",
                  transition: "all 0.3s ease",
                }}
              >
                About Us
                <Box
                  component="span"
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: 0,
                    height: "2px",
                    backgroundColor: "#00BFFF",
                    transition: "all 0.3s ease",
                  }}
                />
              </Link>

              {["Activities", "Programs"].map((item) => (
                <Link
                  key={item}
                  to={`/${item.toLowerCase()}`}
                  style={{
                    color: "#A9C9EA",
                    textDecoration: "none",
                    fontSize: "0.95rem",
                    position: "relative",
                    display: "inline-block",
                    paddingBottom: "4px",
                    transition: "all 0.3s ease",
                  }}
                >
                  {item}
                  <Box
                    component="span"
                    sx={{
                      position: "absolute",
                      left: 0,
                      bottom: 0,
                      width: 0,
                      height: "2px",
                      backgroundColor: "#00BFFF",
                      transition: "all 0.3s ease",
                    }}
                  />
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Column 3: Resources */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, marginBottom: "16px", fontSize: "1.2rem" }}
            >
              Resources
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <Link
                to="/news/"
                style={{
                  color: "#A9C9EA",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  position: "relative",
                  display: "inline-block",
                  paddingBottom: "4px",
                  transition: "all 0.3s ease",
                }}
              >
                News
                <Box
                  component="span"
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: 0,
                    height: "2px",
                    backgroundColor: "#00BFFF",
                    transition: "all 0.3s ease",
                  }}
                />
              </Link>
              <Link
                to="/contact/"
                style={{
                  color: "#A9C9EA",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                  position: "relative",
                  display: "inline-block",
                  paddingBottom: "4px",
                  transition: "all 0.3s ease",
                }}
              >
                Contact Us
                <Box
                  component="span"
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: 0,
                    height: "2px",
                    backgroundColor: "#00BFFF",
                    transition: "all 0.3s ease",
                  }}
                />
              </Link>
            </Box>
          </Grid>

          {/* Column 4: Contact Details */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, marginBottom: "16px", fontSize: "1.2rem" }}
            >
              Contact Us
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#A9C9EA", marginBottom: "8px" }}
            >
              Paktika, Afghanistan
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#A9C9EA", marginBottom: "8px" }}
            >
              Email:{" "}
              <a
                href="mailto:Foundationshall@gmail.com"
                style={{ color: "#00BFFF", textDecoration: "none" }}
              >
                Foundationshall@gmail.com
              </a>
            </Typography>
            <Typography variant="body2" sx={{ color: "#A9C9EA" }}>
              Phone:{" "}
              <a
                href="tel:+1 902-402-5219"
                style={{ color: "#00BFFF", textDecoration: "none" }}
              >
                +123 456 7890
              </a>
            </Typography>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider sx={{ backgroundColor: "#1A2E55", marginY: "24px" }} />

        {/* Bottom Bar */}
        <Box sx={{ textAlign: "center", color: "#A9C9EA", paddingTop: "16px" }}>
          <Typography variant="body2" sx={{ marginBottom: "8px" }}>
            &copy; {new Date().getFullYear()} SHALL Social and Development
            Foundation. All rights reserved.
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", gap: "16px" }}>
            <Link
              to="/terms"
              style={{
                color: "#A9C9EA",
                textDecoration: "none",
                fontSize: "0.85rem",
                position: "relative",
                paddingBottom: "4px",
                transition: "all 0.3s ease",
              }}
            >
              Terms of Service
              <Box
                component="span"
                sx={{
                  position: "absolute",
                  left: 0,
                  bottom: 0,
                  width: 0,
                  height: "2px",
                  backgroundColor: "#00BFFF",
                  transition: "all 0.3s ease",
                }}
                className="hover-line"
              />
            </Link>
            <Link
              to="/privacy"
              style={{
                color: "#A9C9EA",
                textDecoration: "none",
                fontSize: "0.85rem",
                position: "relative",
                paddingBottom: "4px",
                transition: "all 0.3s ease",
              }}
            >
              Privacy Policy
              <Box
                component="span"
                sx={{
                  position: "absolute",
                  left: 0,
                  bottom: 0,
                  width: 0,
                  height: "2px",
                  backgroundColor: "#00BFFF",
                  transition: "all 0.3s ease",
                }}
              />
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
